import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Plus, FileText, Printer } from "lucide-react";
import { printPayslip } from "./constants";

export const PayslipsTab = ({
  payslips,
  onNewPayslip,
  onViewPayslip,
}) => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-lg">Generate Payslip</CardTitle>
          <Button onClick={onNewPayslip} className="bg-green-600 hover:bg-green-700" data-testid="new-payslip-btn">
            <Plus className="h-4 w-4 mr-2" />
            New Payslip
          </Button>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Payslip History</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Employee</TableHead>
                <TableHead>Period</TableHead>
                <TableHead>Gross</TableHead>
                <TableHead>Deductions</TableHead>
                <TableHead>Net Pay</TableHead>
                <TableHead>Created</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {payslips.map((payslip) => (
                <TableRow key={payslip.id} data-testid={`payslip-row-${payslip.id}`}>
                  <TableCell className="font-medium">{payslip.employee_name}</TableCell>
                  <TableCell>{payslip.pay_period_start} - {payslip.pay_period_end}</TableCell>
                  <TableCell>R {payslip.gross_earnings.toFixed(2)}</TableCell>
                  <TableCell className="text-red-600">R {payslip.total_deductions.toFixed(2)}</TableCell>
                  <TableCell className="font-bold text-green-600">R {payslip.net_pay.toFixed(2)}</TableCell>
                  <TableCell>{new Date(payslip.created_at).toLocaleDateString()}</TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Button 
                        variant="outline" 
                        size="sm"
                        onClick={() => onViewPayslip(payslip)}
                        data-testid={`view-payslip-${payslip.id}`}
                      >
                        <FileText className="h-4 w-4" />
                      </Button>
                      <Button 
                        variant="outline" 
                        size="sm"
                        onClick={() => printPayslip(payslip)}
                        data-testid={`print-payslip-${payslip.id}`}
                      >
                        <Printer className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {payslips.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} className="text-center text-gray-500">
                    No payslips generated yet
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
